<!-- .. -->
<!-- JS -->
<!-- .. -->

<script>
	import Infobox from './Infobox.svelte';
	import { idxToFilename, idxToDate, getTooltip, cmap } from './utils.js';
	import { onMount } from 'svelte';
	import { json, select, format, min, max, range } from 'd3';
	import { sliderBottom } from 'd3-simple-slider';

	let data;
	let promise;
	let container
	let deckgl;
	let idxDay = 0;
	let idxTime = 1;
	let colorschemeidx = 0;
	let colorscheme = ['red', 'white', 'green'];

	onMount(async () => {
		// SLIDER
		let N;
		await json('/data/tile_vis/meta.json').then(data => {
			N = data['n_files'];
		})

		var extent = range(Math.floor(N/3));
		let sliderStep = sliderBottom()
			.min(min(extent))
			.max(max(extent))
			.width(window.innerWidth - 301)
			.tickValues(range(2, max(extent)+1, 7))
			.tickFormat(idxDayToDate)
			.step(1)
			.default(0)
			.on('onchange', renderData);

		let gStep = select('div#slider-step')
			.append('svg')
			.attr('width', window.innerWidth - 295 + 55)
			.attr('height', 100)
			.append('g')
			.attr('transform', 'translate(40,55)');
		gStep.call(sliderStep);

		select('p#value-step').text(sliderStep.value());

		// MAP
		deckgl = new deck.DeckGL({
			container,
			map: mapboxgl,
			//mapboxApiAccessToken: 'pk.eyJ1IjoidWJlcmRhdGEiLCJhIjoiY2pudzRtaWloMDAzcTN2bzN1aXdxZHB5bSJ9.2bkj3IiRC8wj3jLThvDGdA',
			mapboxApiAccessToken: 'pk.eyJ1IjoidWxmYXNsYWsiLCJhIjoiY2p0N2EwdHIwMDFybTQzbXVlbHFzb2xmNyJ9.phPTHkncH8agtBXM9MRrJw',
			mapStyle: 'mapbox://styles/mapbox/light-v9',
			initialViewState: {
				latitude: 56.35,
				longitude: 10.5,
				zoom: 6.8,
				maxZoom: 16,
				pitch: 0
			},
			controller: true,
			getTooltip
		});

		renderData(idxDay);
	})

	function renderData(idxDay) {
		let filename = '/data/tile_vis/' + idxDayToFilename(idxDay, idxTime);
		json(filename).then(function(data) {
			let geojsonLayer = new deck.GeoJsonLayer({
				data,
				opacity: 0.5,
				stroked: false,
				filled: true,
				extruded: true,
				wireframe: true,
				fp64: true,
				
				getElevation: f => f.properties.bl * 2,
				getFillColor: f => cmap(f.properties.gr, colorscheme),
				getLineColor: f => [255, 255, 255],
				
				pickable: true
			});

			deckgl.setProps({layers: [geojsonLayer]});
		});
	}

	function idxDayToDate(idxDay) {
		let i = idxDay * 3;
		return idxToDate(i);
	}

	function idxDayToFilename(idx, idxTime) {
		idxDay = idx;
		let i = idxDay * 3 + idxTime;
		let tmp = idxToFilename(i);
		return tmp;
	}

	function update0() {
		if (idxTime != 0) {
			idxTime = 0;
			renderData(idxDay);
		}
	}
	function update1() {
		if (idxTime != 1) {
			idxTime = 1;
			renderData(idxDay);
		}
	}
	function update2() {
		if (idxTime != 2) {
			idxTime = 2;
			renderData(idxDay);
		}
	}

	function updateColorblind() {
		let colorschemes = [
			['red', 'white', 'green'],
			['fc8d62', 'white', '66c2a5'],
			['d95f02', 'white', '1b9e77'],
			['#e74c3c', 'white', '#2980b9'],
			['black', 'white']
		]
		colorschemeidx = (colorschemeidx + 1) % colorschemes.length
		colorscheme = colorschemes[colorschemeidx]
		renderData(idxDay);
	}
</script>


<!-- .... -->
<!-- HTML -->
<!-- .... -->

<div class="time-container bg">
	<label>Date:</label>
	<div class="slider-container">
		<div id="slider-step"></div>
	</div>
	<label>Time:</label>
	<form>
		<div class="flex radio-group">
			<input on:click={update0} type="radio" id="option-one" name="selector">
			<label for="option-one">02–10</label>
			<input on:click={update1} type="radio" id="option-two" name="selector" checked>
			<label for="option-two">10–18</label>
			<input on:click={update2} type="radio" id="option-three" name="selector">
			<label for="option-three">18–02</label>
		</div>
	</form>
</div>

<div class="map-container" bind:this={container}>
	<div id="tooltip"></div>
</div>	

<Infobox/>

<div on:click={updateColorblind} class="colorblindicon">
	<img src="./colorwheel.png" width="30px" height="30px" alt="Toggle colorschemes (for colorblind)">
</div>


<!-- ... -->
<!-- CSS -->
<!-- ... -->

<style>
	input[type=radio] {
		position: absolute;
		visibility: hidden;
		display: none;
	}

	label {
		color: #999999;
		display: inline-block;
		font-size: 12px;
		font-weight: 500;
		padding: 5px;
	}

	input[type=radio]:checked + label{
		color: #dddddd;
		background: #555555;
		cursor: pointer;
	}

	label + input[type=radio] + label {
		border-left: solid 1px #999999;
		cursor: pointer;
	}
	.radio-group {
		border: solid 1px #999999;
		display: inline-block;
		border-radius: 5px;
		overflow: hidden;
	}
	.flex {
		display: flex;
	}
	.map-container {
		position: absolute;
		width: 100vw;
		height: 100vh;
	}
	.bg {
		width: 100%;
		background-color: #f9f9f9;
		border-bottom-style: solid;
		border-bottom-width: 1px;
		border-bottom-color: #000000;

	}
	.slider-container {
		position: relative;
		width: calc(100% - 208px);
		min-height: 1px;
		margin-right: -20px;
		margin-left: -0px;
		margin-top: -45px;
		padding-bottom: -100px;
	}
	.time-container {
		position: absolute;
		display: flex;
		flex-direction: row;
		width: 100%;
		z-index: 1;
	}
	.colorblindicon {
		cursor: pointer;
		position: absolute;
		top: 115px;
		margin-left: 10px;
		opacity: 0.6;
		z-index: 1;
	}
</style>